// removed by extract-text-webpack-plugin
module.exports = {"exception":"antd-pro-exception-exception","imgBlock":"antd-pro-exception-imgBlock","imgEle":"antd-pro-exception-imgEle","content":"antd-pro-exception-content","desc":"antd-pro-exception-desc","actions":"antd-pro-exception-actions"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/src/components/Exception/index.less
// module id = 619
// module chunks = 0